<template>
  <div class="table-wrap">
    <div class="toolbar d-flex">
      <b-btn :disabled="disableCreateBtn" v-show="this.$slots.createForm" size="sm" variant="info" @click="showModal('create')" v-b-tooltip.html.top title="Создать"><i class="fa fa-plus" aria-hidden="true"></i></b-btn>
      <b-btn :disabled="!selectedId" v-show="this.$slots.updateForm" @click="showModal('update')" size="sm" variant="info"  v-b-tooltip.html.top title="Редактировать"><i class="fa fa-pencil" aria-hidden="true"></i></b-btn>
      <b-btn :disabled="!selectedId" size="sm" variant="info" @click="showModal('delete')" ref="delBtn" v-b-tooltip.html.top title="Удалить" class="mr-auto"><i class="fa fa-trash" aria-hidden="true"></i></b-btn>
      <slot name="toolbar"/>
      <b-form-input placeholder="Поиск" id="search-input"/>
      <b-btn size="sm" variant="info" v-b-tooltip.html.top title="Обновить" @click="refreshTable" ><i class="fa fa-refresh" aria-hidden="true"></i></b-btn>
    </div>

    <div class="table-content">
      <b-table
        bordered
        class="ext-table"
        @row-clicked="rowClick"
        :items="provider"
        :fields="fields"
        :hover="true"
        :perPage = "perPage"
        :currentPage = "current"
        ref="table"
        :filter="parsedFilter"
      />
    </div>
    <!-- <div class="table-load-status" v-show="isLoading">
      <i class="fa fa-refresh fa-spin fa-3x fa-fw spinner" ref="spinner"></i>
    </div> -->

    <b-pagination :per-page="perPage" v-model="current" size="sm"/>

    <b-modal no-auto-focus v-model="isModalShow" v-if="isModalShow" ref="tableModal" :hide-footer="true" >

      <template v-if="isCreating">
        <template slot="modal-title">
          {{createFormCfg.title}}
        </template>
        <slot name="createForm" />
      </template>

      <template v-if="isUpdating">
        <template slot="modal-title">
          {{updateFormCfg.title}}
        </template>
        <slot name="updateForm"/>
      </template>

      <template v-if="isDeleting">
        <template slot="modal-title">
          {{deleteFormCfg.title}}
        </template>
        <slot name="deleteForm">
          <ext-form
            :submitProxy="deleteProxy"
            submitBtnText="Удалить"
          >
            <div class="text-center">
              Удалить запись?
            </div> <br>
          </ext-form>
        </slot>
      </template>
    </b-modal>
  </div>
</template>

<script>
import btable from 'bootstrap-vue/lib/components/table'
import ExtForm from '@/components/ExtForm'

const selectedRowCls = 'table-active'

export default {
  extends: btable,
  components: {
    ExtForm
  },
  computed: {
    parsedFilter () {
      return JSON.stringify(this.filter)
    }
  },
  data () {
    return {
      isBusy: false,
      isModalShow: false,
      isCreating: false,
      isUpdating: false,
      isDeleting: false,
      selectedId: '',
      selectedRow: '',
      isLoading: true,
      current: 1
    }
  },
  props: {
    disableCreateBtn: {
      type: Boolean
    },
    filter: {
      type: Object
    },
    loadProxy: {
      type: Object
    },
    deleteProxy: {
      type: Object
    },
    createFormCfg: {
      type: Object,
      default () {
        return {
          title: 'Создать'
        }
      }
    },
    updateFormCfg: {
      type: Object,
      default () {
        return {
          title: 'Обновить'
        }
      }
    },
    deleteFormCfg: {
      type: Object,
      default () {
        return {
          title: 'Удаление'
        }
      }
    },
    perPage: {
      type: Number,
      default: 5
    }
  },
  mounted () {
    this.$refs.table.$on('refreshed', () => {
      this.deselect()
    })
    this.$root.$on('submitSuccess', (data, form) => {
      if (this.$refs.tableModal && this.$refs.tableModal.is_visible) {
        this.$refs.tableModal.hide()
        this.isModalShow = false
        this.refreshTable()
      }
    })
  },
  methods: {
    showModal (operation) {
      this.isModalShow = !this.isModalShow

      this.isCreating = false
      this.isUpdating = false
      this.isDeleting = false

      switch (operation) {
        case 'create':
          this.isCreating = true
          break
        case 'update':
          this.isUpdating = true
          break
        case 'delete':
          this.isDeleting = true
          break
      }
    },
    refreshTable () {
      this.$refs.table.refresh()
    },
    provider (ctx) {
      const method = this.loadProxy.method
      const url = this.loadProxy.url
      const params = '?page=' + ctx.currentPage + '&size=' + ctx.perPage + '&filter=' + encodeURI(ctx.filter)
      let promise = this.$http[method](url + params)
      return promise.then(result => {
        this.isLoading = false
        return (result.data || [])
      }, (error) => {
        this.$noty.error(error.data.message || 'Ошибка при загрузке данных')
        this.isLoading = false
      })
    },
    deselect () {
      this.selectedId = ''
      this.selectedRow = ''
      if (this.$el.querySelector('tr.' + selectedRowCls)) {
        this.$el.querySelector('tr.' + selectedRowCls).classList.remove(selectedRowCls)
      }
    },
    rowClick (item, index, e) {
      if (e.target.nodeName === 'TD') {
        const tr = e.target.parentNode

        if (this.selectedId === item.id) {
          this.selectedId = ''
          this.selectedRow = ''
        } else {
          this.selectedId = item.id
          this.selectedRow = item
        }

        if (!tr.classList.contains(selectedRowCls) && this.$el.querySelector('tr.' + selectedRowCls)) {
          this.$el.querySelector('tr.' + selectedRowCls).classList.remove(selectedRowCls)
        }
        tr.classList.toggle(selectedRowCls)

        this.$emit('select', this.selectedId)
      }
    }
  }
}
</script>

<style>
  #search-input {
    margin: 0 10px;
    max-width: 200px;
    max-height: 31px;
  }
  .modal-content button[type="submit"] {
    float: right;
  }
  .table-wrap .pagination {
    margin-bottom: 0;
    padding: 10px;
    border-top: 3px solid rgb(179, 183, 187);
    border-radius: 0;
  }
  .table-wrap {
    border: 3px solid rgb(179, 183, 187);
  }
  .table-load-status {
    padding: 20px 0;
    text-align: center;
  }
  .table-wrap .table-content {
    overflow-x: auto;
  }
  .table-wrap .pagination-sm .page-link {
    color: black;
  }
  .table-wrap .pagination-sm .page-link.active {
    color: white;
    background-color: #17a2b8;
    border-color: #17a2b8;
  }
  .table-content {
    min-height: 300px;
  }
  .ext-table {
    margin-bottom: 0;
  }
  .ext-table td {
    transition: all .3s ease;
  }
  .ext-table td, .ext-table th {
    border-width: 2px!important;
  }
  .ext-table td:hover {
    cursor: pointer;
  }
  .ext-table th {
    border-top: none;
  }
  .ext-table tr:last-child td {
    border-bottom: none;
  }
  .table-bordered td:first-child, .table-bordered th:first-child {
    border-left: none!important;
  }
  .table-bordered td:last-child, .table-bordered th:last-child {
    border-right: none!important;
  }
  .table-bordered {
    border-left: none;
    border-right: none;
  }
  .toolbar {
    border-bottom: 3px solid rgb(179, 183, 187);
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
  }
  .toolbar button {
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// ExtTable.vue?543ea942